import { shouldNotForwardProps } from '@/shared/helpers';
import { styled } from '@mui/material';
import { getMainContentPaddingX } from './helpers';
export const MainContentBodyStyled = styled('div', shouldNotForwardProps('backdrop', 'headOnly', 'tight', 'loose', 'paddingX', 'paddingTop', 'fullWidth', 'maxWidth'))(({ theme, paddingTop, paddingX, tight, loose, fullWidth, maxWidth }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingTop: paddingTop ?? 0,
    paddingBottom: theme.spacing(4),
    paddingLeft: fullWidth ? 0 : getMainContentPaddingX({ paddingX, tight, loose }),
    paddingRight: fullWidth ? 0 : getMainContentPaddingX({ paddingX, tight, loose }),
    maxWidth,
}));
